module.exports = __webpack_public_path__ + "static/media/kredyt_30.4d6d94ca.png";